export default "__VITE_ASSET__C7W4K5U9__"